import ApopheniaLogger from 'apophenia-javascript-logger';
import { v4 as uuidv4 } from 'uuid';

const UUID = uuidv4();
const FORMAT = '2.0';

export const EVENT_TYPES = Object.freeze({
  click: 'CLICKED',
  dblclick: 'CLICKED',
  mousedown: 'CLICKED',
  input: 'EDITED',
  change: 'EDITED',
  load: 'PAGE_VIEWED',
  focus: 'FOCUSED',
  blur: 'UNFOCUSED',
});

export const INTERACTION_TYPES = Object.freeze({
  CLICKED: 'CLICKED',
  PAGE_VIEWED: 'PAGE_VIEWED',
  EDITED: 'EDITED',
  FOCUSED: 'FOCUSED',
  UNFOCUSED: 'UNFOCUSED',
  SELECTED: 'SELECTED',
  UNSELECTED: 'UNSELECTED',
});

export const EVENT_PRIORITY = Object.freeze({
  INFO: 'INFO',
  ERROR: 'ERROR',
  WARN: 'WARN',
});

export const DEFAULT_ACTION = 'user.interaction.success';

const Logger = ApopheniaLogger.initialize({
  appId: 'sa-portal-app',
  apiKey: window.RT.APOPHENIA,
});

export const sendApopheniaEvent = ({
  body = {},
  priority = EVENT_PRIORITY.INFO,
  action = DEFAULT_ACTION,
  callback = () => {},
  logger = Logger,
}) => {
  /* eslint-disable camelcase */
  body.event_id = UUID;

  const contextData = {
    cv: UUID.toString().concat('.0'),
    epoch_ms: new Date().getTime(),
    event_fmt: FORMAT,
    instance: navigator.userAgent,
    priority,
  };
  /* eslint-enable camelcase */

  logger.send(action, { ...body, ...contextData }, callback);
};
